<template>
    <el-form size="small" :model="searchForm" inline ref="searchForm">
        <el-form-item prop="UpdateTime">
            <el-date-picker
                clearable
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                type="datetimerange"
                :default-time="['00:00:00', '23:59:59']"
                v-model="searchForm.UpdateTime" value-format="yyyy-MM-dd HH:mm:ss"/>
        </el-form-item>
        <el-form-item prop="State">
           <el-select v-model="searchForm.State" placeholder="问卷状态" clearable>
               <el-option v-for="(value, key) in QUESTION_STATUS_USER" :key="key" :label="value" :value="parseInt(key)"/>
           </el-select>
        </el-form-item>
        <el-form-item prop="keyWord">
            <el-input type="text" placeholder="问卷名称" v-model="searchForm.keyWord"/>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click.stop="handleSearch"/>
        </el-form-item>
    </el-form>
</template>

<script>
import { QUESTION_STATUS_USER } from "@/utils/question-config";

export default {
    name: "searchBar",
    data() {
        return {
            searchForm: { UpdateTime: [] },
            QUESTION_STATUS_USER
        }
    },
    methods: {
        handleSearch () {
            const { UpdateTime, ...otherProps } = this.searchForm
            const time = Array.isArray(UpdateTime) ? UpdateTime : []
            this.$refs.searchForm.validate((isPass) => {
                if (isPass) {
                    this.$emit("onSearch", {
                        ...otherProps,
                        StartTime: time[0],
                        EndTime: time[1]
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
